<template>
  <el-card style="margin: 20px auto;width:98%;height: 98%;position: relative;" @current-change="showlanguagetitle">
    <div style="display:flex">
      <div style="width:50%;display: inline">
        <img :src="item.url" class="image" alt="图片加载失败">
      </div>

      <el-divider direction="vertical" style="height:90%;" />
      <!-- 右部 -->
      <div style="width:100%;display: inline">
        <div>
          <el-card class="title" shadow="always">
            <span class="tip">Title:</span>
            <span>{{ item.title }}</span>
          </el-card>

        </div>
        <el-divider style="width:800px"></el-divider>
        <div style="display:flex">
          <el-card shadow="always" style="width:200px">
            <span class="tip">Date:</span>
            <span>{{ item.dataTime }}</span>
          </el-card>
          <el-card shadow="always" style="width:200px;margin-left:40px">
            <span class="tip">Period:</span>
            <span>{{ item.periodTime }}</span>
          </el-card>
        </div>
        <el-divider style="width:800px"></el-divider>

        <div class="dsp">
          <div class="cn">
            <span class="tip">Description(Chinese)</span>
            <span style="display:block">{{ item.descriptionCn }}</span>
          </div>
          <div class="en">
            <span class="tip">Description({{ titlename }})</span>
            <span style="display:block">{{ item.descriptionTranslate }}</span>
          </div>
        </div>

      </div>
      <div class="back" @click="back">返回</div>
    </div>
  </el-card>
</template>


<script>
import axios from "@/util/axios";

export default {
  name: "picture-detail",
  data() {
    return {
      item: {
        title: '暂无数据',
        dataTime: '暂无数据',
        periodTime: '暂无数据',
        descriptionCn: '暂无数据',
        descriptionTranslate: '暂无数据',
        url: '',
        translateLanguage: '',

      },
      titlename: ''

    }

  },

  methods: {
    back() {
      this.$router.go(-1);//返回上一层
    },
    async getPictureDetail(id) {
      const res = await axios.get('/getPictureTextPage?pictureId=' + id)
      this.item = res.data.pictureTextPageVO
      // console.log(this.item)
      //   console.log(res.data.pictureTextPageVO)
      console.log(this.item.translateLanguage)
      this.titlename = this.getLanguageTitle(this.item.translateLanguage)
    },
    getLanguageTitle(translateLanguage) {
      if (translateLanguage == 'Chinese-English') {
        return 'English';
      } else if (translateLanguage == 'Chinese-Japanese') {
        return 'Japanese';
      } else if (translateLanguage == 'Chinese-French') {
        return 'French';
      } else {
        return 'Germany';
      }
      return ''; // 或者根据需要返回其他值
    },
  },
  created() {
    let id = this.$route.query.id
    this.getPictureDetail(id)


  },


}
</script>

<style>
.title {
  width: 85%;
}

.image {
  margin: 0 auto;
  /*padding-top: 70px;*/
  width: 500px;
  display: block;
}

.back {
  width: 50px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: rgb(234, 234, 234);
  color: black;
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  right: 15px;
  bottom: 5px;
}

.tip {
  color: rgb(17, 17, 200);
  font-size: large;
}

.dsp {
  height: 53%;
  width: 85%;
  background-color: whitesmoke;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-radius: 25px;
}

.cn {
  height: 100%;
  width: 47%;
  background-color: white;
  padding: 5px;
}

.en {
  height: 100%;
  width: 47%;
  background-color: white;
  padding: 5px
}

@media (max-width: 1200px) and (min-width: 768px) {
  .title {
    width: 75%;
  }

  .dsp {
    width: 70%;
    height: 53%;
  }

  .cn,
  .en {
    width: 45%;
  }

}
</style>